<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <filterByStatus
            @doFilter="doFilter"
            :statuses="
              currentRoute === 'adminstration-regiscalendarweekCalendar'
                ? []
                : statuses
            "
            :initialStatusValue="filterStatus"
            pageTitle="Đăng ký lịch tuần"
          />
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <div class="list-docs wrapper-content__main list-lich-tuan">
          <sub-header>
            <template #content>
              <div class="leftSection">
                <el-button
                  size="medium"
                  type="success"
                  class="createNew"
                  v-if="hcFlows.length > 0"
                  @click="
                    (isOpenDialogCreate = true), (isEnableDialogCreate = true)
                  "
                >
                  <div class="flex-row flex__center">
                    <i class="fas fa-plus-circle font-size__large"></i>
                    <span>&nbsp;&nbsp;ĐĂNG KÝ</span>
                  </div>
                </el-button>

                <!-- <el-button
                  size="mini"
                  type="success"
                  class="createNew"
                  v-if="hcFlows.length === 0 && filterStatus === 'processed'"
                  @click="
                    (isOpenSendNotifyDlg = true), (isEnableSendNotifyDlg = true)
                  "
                >
                  <div class="flex-row flex__center">
                    <i class="fas fa-arrow-circle-right font-size__large"></i>
                    <span>&nbsp;&nbsp;Gửi tổng hợp thông báo</span>
                  </div>
                </el-button> -->
              </div>

              <searchTemplate
                :keyword="
                  filterStatus === 'processed'
                    ? searchKeyTabProcessed
                    : searchKeyTabSentAndProcessing
                "
                @simpleSearch="search"
                @search="search"
                :isDisableAdvanceSearch="true"
                placeholder="Nhập tên lịch, lãnh đạo, chủ trì và phối hợp để tìm kiếm"
              >
                <template #quickFilter v-if="filterStatus !== 'processed'">
                  <div
                    class="
                      flex-row
                      flex-left__top
                      margin-right-10
                      custom-label__input
                    "
                  >
                    <span class="label-input width__auto">Lịch tuần:</span>
                    <el-date-picker
                      v-model="fromToDate"
                      type="daterange"
                      range-separator="-"
                      format="dd/MM/yyyy"
                      :picker-options="dateRangeOptions"
                    >
                    </el-date-picker>
                  </div>
                  <div class="margin-right-10 txt-center fix-width__small">
                    <multiselect
                      :class="[
                        calendarStatusFilters ? '' : '',
                        'style-fullWidth',
                      ]"
                      :options="calendarStatusFilters"
                      label="name"
                      track-by="id"
                      v-model="calendarStatusFilter"
                      :preselect-first="true"
                      placeholder="-"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :searchable="true"
                      open-direction="bottom"
                      @input="filterByApproveStatus"
                    >
                      <template slot="noResult"
                        >Không tìm thấy dữ liệu phù hợp.
                      </template>
                      <template slot="noOptions">Danh sách trống</template>
                      <template slot="singleLabel" slot-scope="{ option }">
                        <div
                          class="
                            status-doc
                            flex-row flex__left
                            font-size__medium
                          "
                        >
                          &nbsp;&nbsp;
                          <filterIconStatusLT :status="option.id" />
                          <span>{{ option.name }}</span>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </template>
              </searchTemplate>
            </template>
          </sub-header>

          <mainContent
            ref="mainContent1"
            @viewDetail="viewDetail"
            @infiniteHandler="infiniteHandler"
            @sortByColumn="sort"
            v-if="filterStatus !== 'processed'"
            :data="hcCaseCalendars"
            :filterStatus="filterStatus"
          >
          </mainContent>
          <br />
          <hc-calendar-full-calendar
            ref="hcCalendarFullCalendarRef"
            :height="height"
            :display="display"
            :availableFlows="availableFlows"
            @viewDetail="viewDetailFromFullCalendar"
            @capQuyTrinhDeptIdChanged="capQuyTrinhDeptIdChanged"
          ></hc-calendar-full-calendar>

          <registerCalendarDialog
            :isOpen="isOpenDialogCreate"
            :hcFlows="hcFlows"
            v-if="isEnableDialogCreate"
            @dialogClosed="isEnableDialogCreate = false"
            @closeDialog="closeDialog"
            @success="createDialogSuccess"
          />

          <sendNotifyDialog
            v-if="isEnableSendNotifyDlg"
            :isOpen="isOpenSendNotifyDlg"
            @dialogClosed="isEnableSendNotifyDlg = false"
            @closeDialog="closeDialog"
            @success="createDialogSuccess"
          />
        </div>
      </div>

      <div class="extendBar" v-if="filterStatus !== 'processed'">
        <div class="extendItem" @click="viewCalendar">
          <el-tooltip
            class="item"
            effect="dark"
            content="Xem lịch tuần lãnh đạo"
            placement="top"
          >
            <img
              src="../../../assets/img/new-symbol/Calender.svg"
              alt="calendar-icon"
            />
          </el-tooltip>
        </div>
      </div>
    </template>
  </listTemplate>
</template>
<script type="text/javascript">
import moment from "moment";
// import Vue from "vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import headerTemplate from "../../../components/header/main-header.vue";
import constants from "../../../constants";
import { EventBus } from "../../../event-bus.js";
import hanhchinhService from "../../../services/hanhchinhService";
import utils from "../../../services/utils";
import filterIconStatusLT from "../../common/filterIconStatusLT";
import listTemplate from "../../common/list";
import searchTemplate from "../../common/search.vue";
import HcCalendarFullCalendar from "./hc-calendar-full-calendar";
import mainContent from "./LichTuan_MainContent.vue";
import SubHeader from "../../../components/main/sub-header";

export default {
  components: {
    SubHeader,
    HcCalendarFullCalendar,
    listTemplate,
    headerTemplate,
    filterIconStatusLT,
    searchTemplate,
    mainContent,
    VueCtkDateTimePicker,
    // FullCalendar,
    filterByStatus: () => import("../components/filter-by-status-header.vue"),
    registerCalendarDialog: () => import("./LichTuan_Form.vue"),
    sendNotifyDialog: () => import("./LichTuan_SendNotify"),
  },

  data() {
    return {
      fromToDate: [
        moment().startOf("isoWeek").toDate().getTime(),
        moment().add(7, "days").endOf("isoWeek").toDate().getTime(),
      ],
      // calendarPlugins: [listPlugin],
      // defaultView: "listWeek",
      // customButtons: {},
      // header: {
      //   left: "prev,today,next",
      //   center: null,
      //   right: "listDay,listWeek"
      // },
      // titleFormat: {
      //   year: "numeric",
      //   month: "2-digit",
      //   day: "2-digit"
      // },
      // views: {
      //   listDay: {},
      //   listWeek: {}
      // },
      // buttonText: {
      //   today: "Hôm nay",
      //   listWeek: "Tuần",
      //   listDay: "Ngày"
      // },
      // listHcCoopDepts: [],
      // listRequestAccepted: [],
      // listRequestAccepted2: [], //list hiển thị cuối cùng dựa vào list listRequestAccepted
      cooperateDeptIds: [],
      dateRangeOptions: { firstDayOfWeek: 1 },
      filterStatus: "processed",
      hcCaseCalendars: [],
      hcFlows: [],
      availableFlows: [],
      flowCode: "LICH_TUAN",
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,
      isOpenSendNotifyDlg: false,
      isEnableSendNotifyDlg: true,
      isOpenExportReportDlg: false,
      isEnableExportReportDlg: true,
      isOpenBanHanhTuanDialog: false,
      isEnableBanHanhTuanDialog: false,
      isSuccessExportReport: false,
      searchKeyTabProcessed: "",
      searchKeyTabSentAndProcessing: "",
      statuses: [],
      pageable: {
        size: 10,
        page: 0,
        sort: "createTime,desc",
      },
      height: window.innerHeight - 145,
      display: "block",
      // deptId: null,
      exportType: null,
      calendarStatusFilter: null,
      calendarStatusFilters: [
        { id: null, name: "Tất cả", level: 0 },
        // {
        //   id: constants.HC_CALENDAR.APPROVE_STATUS.DA_DANG_KY,
        //   name: "Đã đăng ký",
        //   level: 1,
        // },
        {
          id: constants.HC_CALENDAR.APPROVE_STATUS.CHUA_PHE_DUYET,
          name: "Chưa phê duyệt",
          level: 2,
        },
        {
          id: constants.HC_CALENDAR.APPROVE_STATUS.TAM_PHE_DUYET,
          name: "Tạm phê duyệt",
          level: 3,
        },
        {
          id: constants.HC_CALENDAR.APPROVE_STATUS.DA_BAN_HANH,
          name: "Đã ban hành",
          level: 4,
        },
        {
          id: constants.HC_CALENDAR.APPROVE_STATUS.HUY_YEU_CAU,
          name: "Hủy yêu cầu",
          level: 5,
        },
        {
          id: constants.HC_CALENDAR.APPROVE_STATUS.KHONG_PHE_DUYET,
          name: "Không phê duyệt",
          level: 6,
        },
      ],
      filterOptions: [
        {
          value: constants.LICH_TUAN_PAGE.FILTER.ALL,
          label: "Tất cả",
          iconClass: null,
        },
        {
          value: constants.LICH_TUAN_PAGE.FILTER.CHUA_PHE_DUYET,
          label: "Chờ xử lý",
          iconClass: "Chưa phê duyệt",
        },
        {
          value: constants.LICH_TUAN_PAGE.FILTER.TAM_PHE_DUYET,
          label: "Đã xử lý",
          iconClass: "Tạm phê duyệt",
        },
        {
          value: constants.LICH_TUAN_PAGE.FILTER.DA_BAN_HANH,
          label: "Đã ban hành",
          // iconClass: "fa-check-circle"
        },
        {
          value: constants.LICH_TUAN_PAGE.FILTER.HUY_YEU_CAU,
          label: "Hủy yêu cầu",
          // iconClass: "fa-check-circle"
        },
        {
          value: constants.LICH_TUAN_PAGE.FILTER.KHONG_PHE_DUYET,
          label: "Không phê duyệt",
          // iconClass: "fa-check-circle"
        },
      ],
      // eventsObj: {},
      // groupFilters: [],
      // capQuyTrinhButtons: [],
      // selectedCapQuyTrinhButton: null
    };
  },

  computed: {
    centerButtons() {
      return "myCustomButton myCustomButton2";
    },
    currentRoute() {
      return this.$route.name;
    },
  },

  watch: {
    // listRequestAccepted() {
    //   this.initListRequestAccepted2();
    // },

    isOpenBanHanhTuanDialog(newValue) {
      this.isEnableBanHanhTuanDialog = newValue;
    },
    fromToDate(newValue) {
      if (!newValue) {
        this.fromToDate = [
          moment().startOf("isoWeek").toDate().getTime(),
          moment().add(7, "days").endOf("isoWeek").toDate().getTime(),
        ];
      }
      this.reloadPage();
    },
  },

  created() {
    this.initFlowsAvailable()
      // .then(() => this.initGroupFilters())
      .then(() => this.initFlowsCanStart())
      .then(() => {
        if (this.$store.getters.calendarStatusFilter) {
          this.calendarStatusFilter = this.$store.getters.calendarStatusFilter;
        }
        this.reloadPage();
      });
  },

  mounted() {
    if (
      this.$store.getters.userDeptRole &&
      this.$store.getters.userDeptRole.roleCode !==
        constants.ROLE.CODE.TONG_HOP_LICH_TUAN
    ) {
      this.calendarStatusFilters.push({
        id: constants.HC_CALENDAR.APPROVE_STATUS.DA_DANG_KY,
        name: "Đã đăng ký",
        level: 1,
      });
    }
    EventBus.$on("eventCalled", (options) => {
      this.reloadPage();
      this.reloadForFullCalendar();
    });
  },

  destroyed() {
    this.$store.commit("setCalendarStatusFilter", null);
    EventBus.$off("eventCalled");
  },

  methods: {
    capQuyTrinhDeptIdChanged() {
      this.$router.replace({
        name: "adminstration-regiscalendarweek",
        params: this.$route.params,
        query: this.$route.query,
      });
    },

    reloadForFullCalendar() {
      this.$refs.hcCalendarFullCalendarRef &&
        this.$refs.hcCalendarFullCalendarRef.doSearch({
          keyword: this.searchKeyTabProcessed,
        });
    },

    // initListRequestAccepted2() {
    //   this.listRequestAccepted2 = hanhChinhUtils.initListRequestAccepted2(
    //     this.listRequestAccepted
    //   );
    // },

    // /**
    //  * khởi tạo danh sách filter ở đây là để tránh phải load lại dữ liệu nhiều lần;
    //  * @returns {*}
    //  */
    // initGroupFilters() {
    //   return (this.deptId === constants.TCT_DEPT_ID
    //       ? utils.initGroupFilters(
    //         hcCaseCalendarUserView => hcCaseCalendarUserView.userDeptRoleId
    //       )
    //       : Promise.resolve([])
    //   ).then(groupFilters => (this.groupFilters = groupFilters));
    // },

    hanHanhTuanDialogSuccess() {
      this.isOpenBanHanhTuanDialog = false;
      this.reloadPage();
      this.reloadForFullCalendar();
    },

    // capQuyTrinhButtonsClicked(capQuyTrinhButton) {
    //   if (this.selectedCapQuyTrinhButton.id !== capQuyTrinhButton.id) {
    //     this.selectedCapQuyTrinhButton = capQuyTrinhButton;
    //     this.deptId = capQuyTrinhButton.deptId;
    //     this.initGroupFilters().then(() => this.reloadPage());
    //   }
    // },

    // initCustomButtons() {
    //   this.capQuyTrinhButtons = [];
    //   h.each(this.availableFlows, item =>
    //     this.capQuyTrinhButtons.push({
    //       id: item.deptId,
    //       deptId: item.deptId,
    //       label: item.deptName,
    //       type: "deptId"
    //     })
    //   );
    //   this.capQuyTrinhButtons.push({
    //     id: "viewSharedOnlyButton",
    //     deptId: null,
    //     label: "Lịch tuần được chia sẻ",
    //     type: "shareButton"
    //   });
    //   this.selectedCapQuyTrinhButton = h.find(
    //     this.capQuyTrinhButtons,
    //     item => item.id === this.deptId
    //   );
    // },

    initFlowsAvailable() {
      return hanhchinhService.getFlowsAvailable(this.flowCode).then((res) => {
        this.availableFlows = res.data.hcFlows;
        // if (this.availableFlows && this.availableFlows.length)
        //   this.deptId = this.availableFlows[0].deptId;
        // this.initCustomButtons();
      });
    },

    filterByApproveStatus(event) {
      this.reloadPage();
    },

    initFlowsCanStart() {
      return hanhchinhService
        .getFlowsCanStart(this.flowCode)
        .then((response) => {
          this.hcFlows = response.data.hcFlows;

          if (this.hcFlows.length > 0) {
            this.filterStatus = this.$route.query.filterStatus
              ? this.$route.query.filterStatus
              : "processed";
            if (this.filterStatus === "sent") {
              this.display = "none";
            }
            this.statuses = [
              { value: "sent", name: "Đã gửi yêu cầu" },
              { value: "processed", name: "Lịch tuần" },
            ];
          } else {
            this.filterStatus = this.$route.query.filterStatus
              ? this.$route.query.filterStatus
              : "processing";
            if (this.filterStatus === "processing") {
              this.display = "none";
            }
            this.statuses = [
              { value: "processing", name: "Cần phê duyệt" },
              { value: "processed", name: "Lịch tuần" },
            ];
          }

          if (this.$store.getters.calendarStatusFilter) {
            this.filterStatus = this.hcFlows.length > 0 ? "sent" : "processing";
            this.display = "none";
          }
        });
    },

    doFilter(status) {
      this.filterStatus = status.value;
      this.display = this.filterStatus === "processed" ? "block" : "none";
      this.backToIndex();
      this.reloadPage();
      this.reloadForFullCalendar();
      this.$forceUpdate();
    },

    backToIndex() {
      this.$router.push({
        name: "adminstration-regiscalendarweek",
        query: this.$route.query,
        params: this.$route.params,
      });
    },

    viewCalendar() {
      let params = utils.merge(this.$route.params);
      this.$router.push({
        name: "adminstration-regiscalendarweekCalendar",
        params: params,
        query: null,
      });
    },

    search(keyword) {
      if (this.filterStatus === "processed") {
        this.searchKeyTabProcessed = keyword;
        this.reloadForFullCalendar();
      } else {
        this.searchKeyTabSentAndProcessing = keyword;
        this.reloadPage();
      }
    },

    closeDialog() {
      this.isOpenDialogCreate = false;
      this.isOpenSendNotifyDlg = false;
      this.isOpenExportReportDlg = false;
      this.reloadPage();
    },

    createDialogSuccess() {
      this.isOpenDialogCreate = false;
      this.isOpenSendNotifyDlg = false;
      this.isOpenExportReportDlg = false;
      this.reloadPage();
    },

    reloadPage() {
      this.hcCaseCalendars = [];
      // this.listRequestAccepted = [];
      this.pageable.page = 0;
      if (this.$refs.mainContent1) {
        this.$refs.mainContent1.$refs.infiniteLoading.stateChanger.reset();
      }

      // let monday;
      // let sunday;
      // let approveStatus =
      //   this.calendarStatusFilter && this.calendarStatusFilter.id
      //     ? this.calendarStatusFilter.id
      //     : "";
      // monday = moment()
      //   .subtract(1, "months")
      //   .startOf("isoWeek")
      //   .toDate()
      //   .getTime();
      // sunday = moment()
      //   .add(1, "months")
      //   .endOf("isoWeek")
      //   .toDate()
      //   .getTime();
      // if (this.filterStatus === "processed") {
      //   let pageable = {
      //     size: 1000,
      //     page: this.pageable.page,
      //     sort: this.pageable.sort
      //   };
      //   this.getAcceptedRequests(
      //     monday,
      //     sunday,
      //     this.searchKeyTabProcessed,
      //     this.deptId,
      //     pageable,
      //     approveStatus
      //   );
      // }
    },

    // eventDestroy(e) {
    //   let id = parseInt(e.el.getAttribute("data-vue-id"));
    //   if (this.eventsObj[id]) {
    //     this.eventsObj[id].$destroy(true);
    //   }
    // },

    // eventRender(e) {
    //   let data = e.event.extendedProps;
    //   let component = new FullCalendarLichtuanRowClass({
    //     propsData: {
    //       meetingTitle: e.event.title,
    //       meetingPlace: data.meetingPlace,
    //       parentDeptName: data.parentDeptName,
    //       // leaderNames: data.leaderNames,
    //       chairedUnit: data.chairedUnit,
    //       cooperateDeptNames: h.collect(
    //         data.listHcCoopDepts,
    //         item => item.cooperateDeptName
    //       ),
    //       meetingContent: data.meetingContent,
    //       otherInvolved: data.otherInvolved,
    //       caseMasterId: data.caseMasterId,
    //       hcCaseCalendarId: data.hcCaseCalendarId,
    //       groupFilters: this.groupFilters,
    //       isViewShareMode:
    //         this.selectedCapQuyTrinhButton.type === "shareButton",
    //       hcCaseCalendarView: data.hcCaseCalendarView
    //     }
    //   });
    //   component.$mount();
    //   this.eventsObj[component._uid] = component;
    //   //assign created component to our eventObj with uuid as key (to destroy in future)
    //   this.eventsObj[component._uid] = component;
    //   //set data-vue="{id}"
    //   //append our compiled component to .fc-component
    //   e.el.setAttribute("data-vue-id", component._uid);
    //   e.el.lastElementChild.childNodes[0].remove();
    //   e.el.lastElementChild.appendChild(component.$el);
    //   if (data.isDay) {
    //     e.el.firstElementChild.style.borderLeftWidth = "10px";
    //     e.el.firstElementChild.style.borderLeftColor = "#f5c533";
    //     e.el.cells[1].innerHTML = `<div style="color:#f5c533;">Sáng</div>`;
    //   } else {
    //     e.el.firstElementChild.style.borderLeftWidth = "10px";
    //     e.el.firstElementChild.style.borderLeftColor = "#007aff";
    //     e.el.cells[1].innerHTML = `<div style="color:#007aff;">Chiều</div>`;
    //   }
    // },

    // xử lý thanh cuộn reloadPage
    infiniteHandler($state) {
      let fromDate;
      let toDate;
      let approveStatus =
        this.calendarStatusFilter && this.calendarStatusFilter.id
          ? this.calendarStatusFilter.id ===
            constants.HC_CALENDAR.APPROVE_STATUS.DA_DANG_KY
            ? constants.HC_CALENDAR.APPROVE_STATUS.CHUA_PHE_DUYET
            : this.calendarStatusFilter.id
          : "";
      if (this.fromToDate) {
        fromDate = moment(this.fromToDate[0]).toDate().getTime();
        toDate = moment(this.fromToDate[1]).toDate().getTime();
      } else {
        fromDate = moment().startOf("isoWeek").toDate().getTime();
        toDate = moment().endOf("isoWeek").toDate().getTime();
      }

      if (this.filterStatus === "sent") {
        this.getSentRequests(
          fromDate,
          toDate,
          this.searchKeyTabSentAndProcessing,
          this.pageable,
          $state,
          approveStatus
        );
      } else if (this.filterStatus === "processing") {
        this.getNeedProcessRequests(
          fromDate,
          toDate,
          this.searchKeyTabSentAndProcessing,
          this.pageable,
          $state,
          approveStatus
        );
      }
    },

    // sort
    sort(e) {
      this.pageable.sort = [e.sortBy, e.sortOrder].join(",");
      this.reloadPage();
    },

    // lấy các YCLT đã gửi
    getSentRequests(
      startDate,
      endDate,
      keyword,
      pageable,
      $state,
      approveStatus
    ) {
      return hanhchinhService
        .getSentRequests(startDate, endDate, keyword, pageable, approveStatus)
        .then((response) => {
          let items = response.data.hcCaseCalendars;
          if (items.length > 0) {
            if (
              this.calendarStatusFilter.id ===
              constants.HC_CALENDAR.APPROVE_STATUS.DA_DANG_KY
            ) {
              items = items.filter(
                (item) => item.requestUserId === this.$store.getters.user.id
              );
            }
            this.hcCaseCalendars.push(...items);
            this.pageable.page++;
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    },

    // lấy các YCLT cần duyệt
    getNeedProcessRequests(
      startDate,
      endDate,
      keyword,
      pageable,
      $state,
      approveStatus
    ) {
      return hanhchinhService
        .getNeedProcessRequests(
          startDate,
          endDate,
          keyword,
          pageable,
          approveStatus
        )
        .then((response) => {
          let items = response.data.hcCaseCalendars;
          if (items && items.length > 0) {
            if (
              this.calendarStatusFilter.id ===
              constants.HC_CALENDAR.APPROVE_STATUS.DA_DANG_KY
            ) {
              items = items.filter(
                (item) => item.requestUserId === this.$store.getters.user.id
              );
            }
            this.hcCaseCalendars.push(...items);
            this.pageable.page++;
            $state.loaded();
          } else {
            if (typeof $state !== "undefined") {
              $state.complete();
            }
          }
        });
    },

    // // lấy các YCLT đã duyệt
    // getAcceptedRequests(
    //   startDate,
    //   endDate,
    //   keyword,
    //   deptId,
    //   pageable,
    //   approveStatus
    // ) {
    //   return hanhchinhService
    //     .getAcceptedRequestsIncludeCoopDepts(
    //       startDate,
    //       endDate,
    //       keyword,
    //       deptId,
    //       pageable,
    //       approveStatus
    //     )
    //     .then(response => {
    //       let items = response.data.hcCaseCalendars;
    //       items.forEach(item => {
    //         this.listRequestAccepted.push({
    //           id: item.hcCaseCalendarView.caseMasterId,
    //           title: item.hcCaseCalendarView.meetingTitle,
    //           meetingPlace: item.hcCaseCalendarView.meetingPlace,
    //           meetingContent: item.hcCaseCalendarView.meetingContent,
    //           chairedUnit: item.hcCaseCalendarView.chairedUnit,
    //           leaderNames: item.hcCaseCalendarView.leaderNames,
    //           listHcCoopDepts: item.hcCoopDepts,
    //           otherInvolved: item.hcCaseCalendarView.otherInvolved
    //             ? item.hcCaseCalendarView.otherInvolved
    //             : "",
    //           createTime:
    //             `` +
    //             moment(item.hcCaseCalendarView.createTime).format(
    //               "DD/MM/YYYY HH:mm"
    //             ),
    //           start: moment(item.hcCaseCalendarView.startTime).format(
    //             "YYYY-MM-DDTHH:mm:ss"
    //           ),
    //           end: moment(item.hcCaseCalendarView.endTime).format(
    //             "YYYY-MM-DDTHH:mm:ss"
    //           ),
    //           startTime_: item.hcCaseCalendarView.startTime,
    //           endTime_: item.hcCaseCalendarView.endTime,
    //           isDay:
    //             new Date(item.hcCaseCalendarView.startTime).getHours() < 12,
    //           caseMasterId: item.hcCaseCalendarView.caseMasterId,
    //           hcCaseCalendarId: item.hcCaseCalendarView.id,
    //           parentDeptName: item.hcCaseCalendarView.parentDeptName,
    //           hcCaseCalendarView: item.hcCaseCalendarView
    //         });
    //       });
    //     });
    // },
    // //lay danh sach don vi phoi hop

    // xem chi tiet lich tuan
    viewDetail(e) {
      this.viewDetail_(e.caseMasterId);
    },

    viewDetailFromFullCalendar({ caseMasterId }) {
      console.log("viewDetailFromFullCalendar");
      this.viewDetail_(caseMasterId);
    },

    viewDetail_(caseMasterId) {
      let params = utils.merge(this.$route.params, { id: caseMasterId });
      this.$router.push({
        name: "adminstration-regiscalendarweek-detail",
        params: params,
        query: null,
      });
    },
  },
};
</script>
<style type="text/css">
.list-lich-tuan .list.lichtuan-maincontent .scroll-area {
  max-height: calc(100% - 90px) !important;
}

.grid-container {
  display: grid;
  overflow: hidden;
  width: 45%;
  float: left;
  grid-template-columns: auto;
  grid-gap: 5px;
}

.grid-container:last-child {
  width: 55%;
}

.grid-container > .item {
  font-size: var(--font-small);
  padding-right: 10px;
}

.grid-container:first-child > .item {
  padding-left: 10px;
}

.grid-container > .item > .title {
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
}

.grid-container > .item > .font-size__small {
  font-size: 13px;
  line-height: 20px;
}

.fc-widget-header {
  background: var(--color-dark) !important;
}

.fc-widget-header > span {
  color: white;
}

.font_blued {
  color: var(--color-blue);
}

.leftSection {
  /* width: 100%; */
}

.capQuyTrinhButtonDiv {
  text-align: center;
  position: absolute;
}

.capQuyTrinhButton {
  font-size: var(--font-medium);
  font-weight: bolder;
  background-color: var(--color-dark);
  color: var(--color-white);
  line-height: 0.5;
}

.capQuyTrinhButton:hover {
  color: #fff !important;
  background-color: #1e2b37 !important;
}

.capQuyTrinhButton:focus {
  color: #fff !important;
  background-color: #1e2b37 !important;
}

.el-date-editor--daterange.el-input__inner {
  width: 210px;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/LichTuan_Index.vue